import BackendService from './BackendService';

async function getWarehouses(params = {}) {
  return BackendService.getData('/warehouses/', {}, params);
}

async function createWarehouse(data) {
  return BackendService.postData('/warehouses/', data);
}

async function updateWarehouse(id, data) {
  return BackendService.patch(`/warehouses/${id}/`, data);
}

async function deleteWarehouse(id) {
  return BackendService.destroy(`/warehouses/${id}/`);
}

async function getWarehouseProducts(params = {}) {
  return BackendService.getData('/warehouse/products/', {}, params);
}

async function importDefaultStock(warehouseId) {
  return BackendService.postData('/warehouse/products/import/', { warehouse_id: warehouseId });
}

async function adjustWarehouseStock(id, data) {
  return BackendService.postData(`/warehouse/products/${id}/adjust_stock/`, data);
}

const WarehouseService = {
  getWarehouses,
  createWarehouse,
  updateWarehouse,
  deleteWarehouse,
  getWarehouseProducts,
  importDefaultStock,
  adjustWarehouseStock,
};

export default WarehouseService;
